import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Sidelines crashed:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-cream px-6 text-center">
          <div className="max-w-md">
            <div className="text-5xl mb-4">⚽</div>
            <h1 className="font-display text-2xl font-bold text-pitch mb-3">Full-time whistle</h1>
            <p className="text-muted-foreground mb-6">
              Something went wrong on the pitch. A quick refresh usually sorts it out.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 rounded-full bg-pitch text-cream font-semibold hover:bg-pitch-deep transition-colors"
              data-testid="error-reload-btn"
            >
              Restart the match
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
